// src/components/QuarantineChip.jsx
//
// WP5 (docs/coverage-guided-capture-spec.md §9) — small shared "Quarantined"
// badge for a per-check result that the proxy's flaky-check guardrail has
// demoted (fail -> warn, `result.quarantined === true`). Shared by
// ChecksPage.jsx's ResultsTable/RollupRow context, LaunchPage.jsx's
// CheckResultBlock, and BuildValidationPanel.jsx's perValidation rows, so all
// three render the exact same badge instead of drifting copies. The status
// chip next to this one still shows the delivered status (warn) as-is — this
// component never re-scores or re-labels that chip, it only adds context.
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

const DEFAULT_NOTE = 'Quarantined: this check’s verdict has flip-flopped across recent runs, so it’s softened to warn until a human releases it.';

export default function QuarantineChip({ note, size = 'small' }) {
  return (
    <Tooltip title={note || DEFAULT_NOTE}>
      <Chip
        size={size}
        label="Quarantined"
        color="warning"
        variant="outlined"
        sx={{ fontWeight: 600 }}
      />
    </Tooltip>
  );
}
